var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivePorts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic ports",
    clipPath: "url(#clip0_9146_76160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-ports"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 5H2.5C1.11917 5 0 6.11917 0 7.5V13.3333C0 14.7142 1.11917 15.8333 2.5 15.8333H17.5C18.8808 15.8333 20 14.7142 20 13.3333V7.5C20 6.11917 18.8808 5 17.5 5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6667 10.0026V9.16927C11.6667 8.70927 11.2933 8.33594 10.8333 8.33594H9.16667C8.70667 8.33594 8.33333 8.70927 8.33333 9.16927V10.0026C7.87333 10.0026 7.5 10.3759 7.5 10.8359V11.6693C7.5 12.1293 7.87333 12.5026 8.33333 12.5026H11.6667C12.1267 12.5026 12.5 12.1293 12.5 11.6693V10.8359C12.5 10.3759 12.1267 10.0026 11.6667 10.0026Z",
    fill: "#65B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83366 10.0026V9.16927C5.83366 8.70927 5.46033 8.33594 5.00033 8.33594H3.33366C2.87366 8.33594 2.50033 8.70927 2.50033 9.16927V10.0026C2.04033 10.0026 1.66699 10.3759 1.66699 10.8359V11.6693C1.66699 12.1293 2.04033 12.5026 2.50033 12.5026H5.83366C6.29366 12.5026 6.66699 12.1293 6.66699 11.6693V10.8359C6.66699 10.3759 6.29366 10.0026 5.83366 10.0026Z",
    fill: "#65B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4997 10.0026V9.16927C17.4997 8.70927 17.1263 8.33594 16.6663 8.33594H14.9997C14.5397 8.33594 14.1663 8.70927 14.1663 9.16927V10.0026C13.7063 10.0026 13.333 10.3759 13.333 10.8359V11.6693C13.333 12.1293 13.7063 12.5026 14.1663 12.5026H17.4997C17.9597 12.5026 18.333 12.1293 18.333 11.6693V10.8359C18.333 10.3759 17.9597 10.0026 17.4997 10.0026Z",
    fill: "#65B2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePorts);
export default __webpack_public_path__ + "static/media/active-ports.b6761d46c928050d5a82bb5e90e72821.svg";
export { ForwardRef as ReactComponent };